import PageRotationControls from './PageRotationControlsContainer';

export default PageRotationControls